import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IhmSnackbarComponent, IhmSnackbarContentComponent } from './ihm-snackbar.component';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [IhmSnackbarComponent, IhmSnackbarContentComponent],
  exports: [IhmSnackbarComponent, IhmSnackbarContentComponent],
  entryComponents: [IhmSnackbarContentComponent]
})
export class IhmSnackbarModule {}
